const BASE = process.env.REACT_APP_API_URL || 'https://groovie-business-api-production.up.railway.app/api/v1';

export const api = {
  get: async (path) => {
    const token = localStorage.getItem('broadcast_token');
    const res = await fetch(`${BASE}${path}`, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Request failed'); }
    return res.json();
  },
  post: async (path, body) => {
    const token = localStorage.getItem('broadcast_token');
    const res = await fetch(`${BASE}${path}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Request failed'); }
    return res.json();
  },
  put: async (path, body) => {
    const token = localStorage.getItem('broadcast_token');
    const res = await fetch(`${BASE}${path}`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Request failed'); }
    return res.json();
  },
  patch: async (path, body) => {
    const token = localStorage.getItem('broadcast_token');
    const res = await fetch(`${BASE}${path}`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Request failed'); }
    return res.json();
  },
  del: async (path) => {
    const token = localStorage.getItem('broadcast_token');
    const res = await fetch(`${BASE}${path}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.detail || 'Request failed'); }
    return res.json();
  }
};

export const getStation  = () => JSON.parse(localStorage.getItem('broadcast_station') || 'null');
export const setStation  = (s) => localStorage.setItem('broadcast_station', JSON.stringify(s));
export const clearAuth   = () => { localStorage.removeItem('broadcast_token'); localStorage.removeItem('broadcast_station'); };
export const isLoggedIn  = () => !!localStorage.getItem('broadcast_token');
